import { useQuery } from '@tanstack/react-query';

import { useAuthSession } from '@/features/auth/useAuthSession';
import { fetchPacks } from '@/services/payments';

/** Активные пакеты. Цены и состав приходят из базы — в компонентах их нет. */
export function usePacks() {
  const { status } = useAuthSession();

  return useQuery({
    queryKey: ['credit-packs'],
    queryFn: fetchPacks,
    enabled: status === 'ready',
  });
}
